module.exports = __webpack_public_path__ + "img/rocks.d644602b.png";